const data = [
  {
    type: 'cmp',
    banner: {
      img: '/images/product/cmp.jpg',
      content: {
        title: '产融管理运营平台',
        desc: '产融管理运营平台是明心数智基于行业领先的物联网、区块链、大数据、云计算和人工智能技术，并融合产业多维数据、先进算法和经营评估预测模型，推出的一款协助产业互联网平台对上下游小微企业进行产融管理的线上化平台。',
        buttonText: '立即咨询,CMP介绍',
        buttonType: 'url,modal'
      }
    },
    product: [
      { title: '全周期账期管理', desc: '个性化账期管理，灵活配置账期信息' },
      { title: '企业经营评估报告', desc: '风控情况动态监测；预警消息实时推送' },
      { title: '动态经营预警', desc: '场景数据结构化，产业经营智能监测' },
      { title: '产业金融直达', desc: '架设产融对接桥梁，账期情况实时跟进' },
    ],
    advantage: [
      { title: '流转高效，机制规范', desc: '拥有标准化的审批流和规范的决策机制，流转更高效' },
      { title: '全量数据留存且透明', desc: '可视化的数据展示，让每一项工作内容都能精准定位' },
      { title: '风险多维度监测', desc: '多角度监测企业经营，生产等情况，降低产融风险' },
      { title: '银行直通，账期自制', desc: '交易订单直连银行，可灵活配置账期，智能提醒' },
    ]
  },
  {
    type: 'oap',
    banner: {
      img: '/images/product/oap.jpg',
      content: {
        title: '经营评估平台',
        desc: '集合丰富的产业链数据，通过规则引擎实现数据、指标、规则、模型、决策流等模块的统一管理与灵活配置，实现对产业全周期的动态评估、动态监测、动态预警等，为银行、供应链金融、中小微企业提供智能、高效的产业经营评估方案。',
        buttonText: '立即咨询',
        buttonType: 'url'
      }
    },
    product: [
      { title: '全面风险监测', desc: '接入四大场景（生产，物流，仓储，贸易）监控数据，及三方征信数据，舆情数据，实现全面风险监测' },
      { title: '规则引擎', desc: '多类型规则组件，支持差异化规则配置需求，简单易操作' },
      { title: '监测预警', desc: '丰富的预警指标，支持差异化预警需求，提供灵活可配的产业全周期监测方案' },
      { title: '经营评估报告', desc: '基于丰富的行业经验及海量数据结合人工智能技术，输出分行业的产业经营评估报告' },
    ],
    advantage: [
      { title: '海量数据', desc: '接入四大场景（生产，物流，仓储，贸易）监控数据，外部三方数据，舆情数据' },
      { title: '预警方案灵活可配', desc: '可灵活设置监测企业场景、预警规则、预警阈值、预警分发规则，实现个性化监测' },
      { title: '全周期预警', desc: '关注产业全周期风险，实现自动风险预警，实时风险推送，提升效率的同时也提高风险防控能力' },
    ]
  },
  {
    type: 'imp',
    banner: {
      img: '/images/product/imp.jpg',
      content: {
        title: '产业物联网平台',
        desc: 'IMP平台提供安全可靠的设备连接通信能力，支持IoT数据采集上云，流转数据和云端指令下发设备。此外，也提供方便快捷的设备管理能力，支持物模型定义，数据结构化存储，和远程调试、监控、运维。',
        buttonText: '立即咨询',
        buttonType: 'url'
      }
    },
    product: [
      { title: '物接入', desc: '支持多种接入协议，支持设备直连、网关代理、云云对接多种上云方式' },
      { title: '物管理', desc: '以物模型抽象出同类设备的功能，提供统一的北向接口' },
      { title: '物运维', desc: '以远程调试和监控，完成全生命周期监控' },
    ],
    advantage: [
      { title: '3天接入，5天上线', desc: '内置多种协议支持，快速开发和上线' },
      { title: '千万级接入，百万级并发', desc: '支持千万级设备水平扩展，百万级以上的并发连接' },
      { title: '低成本运维', desc: '通过设备链路的日志分析、实时级别的监控和告警，可实时感知业务异常并及时处置' },
    ]
  },
  {
    type: 'srp',
    banner: {
      img: '/images/product/srp.jpg',
      content: {
        title: '产融方案设计平台',
        desc: '涵盖金融方案设计功能，产业监控方案推荐功能，明心项目推荐功能，为金融机构高效产出金融产品方案。',
        buttonText: '立即咨询',
        buttonType: 'url',
        // className: 'color-fff'
      }
    },
    product: [
      { title: '财务报表', desc: '智能识别财务报表，自动计算财务指标' },
      { title: '行研报告', desc: '海量行业研究数据，掌握行业最新动向' },
      { title: '企业报告', desc: '深度分析企业现况，把控企业风险信息' },
      { title: '方案推荐', desc: '精准推荐金融方案，快速制定方案内容' },
    ],
    advantage: [
      { title: '智能识算', desc: '财报精准识别，快速计算财务指标，极大缓解计算压力' },
      { title: '海量数据', desc: '拥有丰富的行业和企业信息' },
      { title: '配置灵活', desc: '灵活配置报告内容，图片文字一应俱全' },
    ]
  },
  {
    type: 'bmp',
    banner: {
      img: '/images/product/bmp.jpg',
      content: {
        title: '产业区块链平台',
        desc: '明心产业区块链管理平台（简称BMP），是以IBM Hyperledger Fabric技术为底层、采用B/S架构技术打造的一套高效可用的服务及管理平台，能够为产业领域的多方企业接入区块链业务提供准入许可、高效部署、接口对接及运营管控等服务。',
        buttonText: '立即咨询',
        buttonType: 'url'
      }
    },
    product: [
      { title: '完整全面的身份管理', desc: '支持用户多种角色与权限配置，明确的证书申请与组织管理' },
      { title: '多节点群与多通道的扩展性', desc: '支持节点扩展以及通道配置管理' },
      { title: '链码自动化部署与升级', desc: '支持链码合约在指定节点上的灵活部署与升级管理' },
      { title: '监控预警与链上浏览', desc: '支持实时系统运行状况监测以及区块链浏览功能' },
    ],
    advantage: [
      { title: '高性能服务', desc: '区块链服务平台采用微服务设计，实现高可用、高性能，TPS可达3000，基于阿里云部署，节点扩展性高' },
      { title: '参与者身份透明化', desc: '多方参与者具有多级权限细分，身份准入许可' },
      { title: '数据安全性高', desc: '支持区块链隐私数据，以及采用多种密码学保障数据的安全性' },
      { title: '集成区块链浏览器', desc: '不仅支持实时监测系统运行状况并及时预警功能，而且具备相关业务的区块信息浏览功能' },
    ]
  },
  {
    type: 'fap',
    banner: {
      img: '/images/product/fap.jpg',
      content: {
        title: '跨境经营评估平台',
        desc: '致力于为跨境电商企业提供更可控、更高效、更具性价比的关、税申报一体化SaaS服务和数字化供应链金融解决方案。',
        buttonText: '立即咨询',
        buttonType: 'url'
      }
    },
    product: [
      { title: '一站式报关、退税申报窗口', desc: '平台集成报关、退税，数据直接和海关、税局，用户可直接在平台内完成报关、退税申报' },
      { title: '跨境电商业务标准凭证接口', desc: '自动收集包括运单/提货单、入仓单、收付款单、销售订单、服务订单、保险凭证等供单证备案用' },
      { title: '金融赋能', desc: '解决电商上下游结汇款、物流款及采购货款的资金需求' },
    ],
    advantage: []
  },
]

export default data